"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@popperjs/core");

var _useResizeObserver = _interopRequireDefault(require("../../hooks/__internal__/useResizeObserver"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const Popover = ({
  children,
  placement,
  disablePortal,
  reference,
  onFirstUpdate,
  modifiers
}) => {
  const elementDOM = (0, _react.useRef)();

  if (!elementDOM.current && !disablePortal) {
    elementDOM.current = document.createElement("div");
    document.body.appendChild(elementDOM.current);
  }

  const popperInstance = (0, _react.useRef)();
  const popperRef = (0, _react.useRef)();
  let content;
  let popperElementRef;

  const childRef = _react.default.Children.only(children).ref;

  if (childRef) {
    content = children;
    popperElementRef = childRef;
  } else {
    content = /*#__PURE__*/_react.default.cloneElement(children, {
      ref: popperRef
    });
    popperElementRef = popperRef;
  }

  (0, _useResizeObserver.default)(reference, () => {
    var _popperInstance$curre;

    popperInstance === null || popperInstance === void 0 ? void 0 : (_popperInstance$curre = popperInstance.current) === null || _popperInstance$curre === void 0 ? void 0 : _popperInstance$curre.update();
  });
  (0, _react.useLayoutEffect)(() => {
    if (reference.current) {
      popperInstance.current = (0, _core.createPopper)(reference.current, popperElementRef.current, {
        placement,
        onFirstUpdate,
        modifiers: [{
          name: "computeStyles",
          options: {
            gpuAcceleration: false,
            roundOffsets: false
          }
        }, ...(modifiers || [])]
      });
    }

    return () => {
      if (popperInstance.current) {
        popperInstance.current.destroy();
        popperInstance.current = null;
      }
    };
  }, [modifiers, onFirstUpdate, placement, popperElementRef, reference]);
  (0, _react.useEffect)(() => {
    return () => {
      if (!disablePortal) {
        document.body.removeChild(elementDOM.current);
      }
    };
  }, [disablePortal]);

  if (disablePortal) {
    return content;
  }

  return /*#__PURE__*/_reactDom.default.createPortal(content, elementDOM.current);
};

Popover.propTypes = {
  // Element to be positioned, has to be a single node and has to accept `ref` and `style` props
  children: _propTypes.default.node.isRequired,
  // Placement of children in relation to the reference element
  placement: _propTypes.default.oneOf(["auto", "auto-start", "auto-end", "top", "top-start", "top-end", "bottom", "bottom-start", "bottom-end", "right", "right-start", "right-end", "left", "left-start", "left-end"]),
  // Optional modifiers array, for more information and object structure go to:
  // https://popper.js.org/docs/v2/constructors/#modifiers
  modifiers: _propTypes.default.array,
  // Optional onFirstUpdate funcition, for more information go to:
  // https://popper.js.org/docs/v2/constructors/#modifiers
  onFirstUpdate: _propTypes.default.func,
  // When true, children are not rendered in portal
  disablePortal: _propTypes.default.bool,
  // Reference element, children will be positioned in relation to this element - should be a ref
  reference: _propTypes.default.shape({
    current: _propTypes.default.any
  })
};
var _default = Popover;
exports.default = _default;